export { CoverImageFormFragmentComponent } from './lib/cover-image-form-fragment.component';
export { COVER_IMAGE_CONFIG_INJECTION_TOKEN } from './lib/config-injection-token/cover-image-config-injection-token';
